import React from "react";
import { Box, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";

const MarkdownContent = ({ content }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <ReactMarkdown
        components={{
          h1: ({ node, ...props }) => (
            <Typography
              variant="h4"
              sx={{ color: "#242f3f", mb: 3, fontWeight: 600 }}
              {...props}
            />
          ),
          h2: ({ node, ...props }) => (
            <Typography
              variant="h5"
              sx={{ color: "#242f3f", mt: 4, mb: 2, fontWeight: 500 }}
              {...props}
            />
          ),
          h3: ({ node, ...props }) => (
            <Typography
              variant="h6"
              sx={{ color: "#242f3f", mt: 3, mb: 2, fontWeight: 500 }}
              {...props}
            />
          ),
          p: ({ node, ...props }) => (
            <Typography
              variant="body1"
              sx={{ color: "#444", mb: 2, lineHeight: 1.6 }}
              {...props}
            />
          ),
          ul: ({ node, ...props }) => (
            <Box component="ul" sx={{ mb: 2, pl: 2 }}>
              {props.children}
            </Box>
          ),
          ol: ({ node, ...props }) => (
            <Box component="ol" sx={{ mb: 2, pl: 2 }}>
              {props.children}
            </Box>
          ),
          li: ({ node, ...props }) => (
            <Typography
              component="li"
              variant="body1"
              sx={{ color: "#444", mb: 1, lineHeight: 1.6 }}
              {...props}
            />
          ),
          code: ({ node, inline, ...props }) => (
            inline ? (
              <Box
                component="code"
                sx={{
                  backgroundColor: "#f5f7f9",
                  padding: "0.2em 0.4em",
                  borderRadius: "3px",
                  fontSize: "0.9em",
                  fontFamily: "monospace",
                }}
                {...props}
              />
            ) : (
              <Box
                component="pre"
                sx={{
                  backgroundColor: "#f5f7f9",
                  padding: "1em",
                  borderRadius: "4px",
                  overflowX: "auto",
                  mb: 2,
                }}
              >
                <Box
                  component="code"
                  sx={{
                    fontFamily: "monospace",
                    fontSize: "0.9em",
                    display: "block",
                  }}
                  {...props}
                />
              </Box>
            )
          ),
          blockquote: ({ node, ...props }) => (
            <Box
              component="blockquote"
              sx={{
                borderLeft: "4px solid #FF5336",
                pl: 2,
                py: 1,
                my: 2,
                backgroundColor: "rgba(255, 83, 54, 0.05)",
              }}
              {...props}
            />
          ),
          table: ({ node, ...props }) => (
            <Box
              component="table"
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                mb: 2,
                "& th, & td": {
                  border: "1px solid #e2e6f3",
                  padding: "8px",
                },
                "& th": {
                  backgroundColor: "#f5f7f9",
                  fontWeight: 600,
                },
              }}
              {...props}
            />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
};

export default MarkdownContent; 